var App = App || {};

App.Base = (function ($) {
    'use strict';

    function init() {
        HashSupport();
        ResponsiveTables();
        TableScrollIndicator();
        onScrollInit($('.os-animation'));

        $('.staggered-animation').each(function () {
            var $this = $(this);
            onScrollInit($this, $this.parents('.staggered-animation-container'));
        });
    }

    function HashSupport() {

        const Hash = $(location.hash);

        if (Hash.length == 1) {

            if (Hash.attr("data-bs-toggle") == "collapse") {
                const Target = $(Hash.attr("data-bs-target"));
                const Panel = document.getElementById(Target.attr("id"));
                const Collapse = new bootstrap.Collapse(Panel);
                Collapse.show();
            }

            else if (Hash.attr("data-bs-toggle") == "tab") {
                const Tab = new bootstrap.Tab(Hash);
                Tab.show();
            }

            else if (Hash.hasClass("modal")) {
                const Modal = new bootstrap.Modal(Hash);
                Modal.show();
            }
        }
    }

    function onScrollInit(items, $trigger) {
        items.each(function () {
            var $osElement = $(this),
                osAnimationClass = $osElement.attr('data-os-animation'),
                osAnimationDelay = $osElement.attr('data-os-animation-delay');

            $osElement.css({
                '-webkit-animation-delay': osAnimationDelay,
                '-moz-animation-delay': osAnimationDelay,
                'animation-delay': osAnimationDelay
            });

            var $osTrigger = ($trigger) ? $trigger : $osElement;

            $osTrigger.waypoint(function () {
                var waypoint = this;

                $osElement
                    .one('animationend', function () {
                        $osElement
                            .addClass('animation-complete')
                            .removeClass('animate__animated');

                        waypoint.destroy();
                    })
                    .addClass('animate__animated')
                    .addClass(osAnimationClass);
            }, {
                triggerOnce: true,
                offset: '90%'
            });
        });
    }

    // https://davidwalsh.name/query-string-javascript
    function GetUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    function ResponsiveTables() {
        var $tables = $('.rich-text table');

        $tables.each(function () {
            if (!$(this).hasClass('.table')) {
                $(this).addClass('table').wrap('<div class="table-responsive"></div>');
            }
        });
    }

    function TableScrollIndicator() {
        var $tables = $('.table');

        $tables.each(function () {
            if (!$(this).closest('.table-responsive').length) {
                $(this).wrap('<div class="table-responsive"></div>');
            }
        });

        var $responsiveTableWrappers = $('.table-responsive');
        $responsiveTableWrappers.append('<div class="scroll-indicator"><span class="visually-hidden">Scroll Right</span></div>');

        $responsiveTableWrappers.each(function () {
            var $indicator = $(this).children('.scroll-indicator');
            if ($(this).children('.table').width() > $(this).width()) { $indicator.show(); }
            $(this).one("scroll", function () {
                $indicator.fadeOut();
            });
        });

        $('.nav-tabs button').on('shown.bs.tab', function (event) {
            setTimeout(function () {
                TableScrollRedetermineIndicatorVisibility()
            }, 500);
        });
    }

    function TableScrollRedetermineIndicatorVisibility() {
        var $responsiveTableWrappers = $('.table-responsive');

        $responsiveTableWrappers.each(function () {
            var $indicator = $(this).children('.scroll-indicator');
            if ($(this).children('.table').width() > $(this).width()) { $indicator.show(); }
        });
    }

    return {
        init: init,
        GetUrlParameter: GetUrlParameter
    };

})(jQuery);

$(function () {
    App.Base.init();
});